module.exports = __webpack_public_path__ + "img/lg_lliege_inline.2f1ddf10.png";